<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
      <img src="~@/assets/logo.png" alt="logo">
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>

export default {
  name: 'Logo',
  props: {
    title: {
      type: String,
      default: 'CDB',
      required: false
    },
    showTitle: {
      type: Boolean,
      default: true,
      required: false
    }
  }
}
</script>
<style scoped>
.sider .logo a{
  display: flex;
  align-items: center;
  height: 64px;
}
.sider .logo img{
  height: 32px;
  width: initial;
}
.sider .logo h1{
  margin: 0 0 0 15px;
  white-space: nowrap;
}
</style>
